import renderDropZoneField from "@/shared/components/form/DropZone";
import renderDropZoneMultiField from "@/shared/components/form/DropZoneMultiple";
import { renderMaskedField } from "@/shared/components/form/FormField";
import { MultiSelectField } from "@/shared/components/form/MultiSelect";
import PasswordField from "@/shared/components/form/Password";
import renderSelectField from "@/shared/components/form/Select";
import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router";
import { Button, ButtonToolbar, Col } from "reactstrap";
import styled from "styled-components";
import FormField from "./components/FormField";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";
import SkeletonLoading from "./components/SkeletonLoading";
import LocationPicker from "./components/LocationPicker";
function formTypeCheck(form) {
  switch (form.type ?? "text") {
    case "number":
      return {
        step: form.step ?? "any",
        type: "number",
      };
    case "email":
      return {
        type: "email",
      };
    case "select":
      return {
        type: "select",
        options: form?.options,
      };
    case "mobile":
      return {
        type: "mobile",
        mask: [
          "(",
          "+",
          "8",
          "8",
          ")",
          " ",
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
        ],
      };
    case "textarea":
      return {
        type: "textarea",
      };
    case "password":
      return {
        type: "password",
      };
    case "file":
      return {
        type: "file",
      };
    case "files":
      return {
        type: "files",
      };
    case "location":
      return {
        type: "location",
      };
    case "custom":
      return {
        type: "custom",
        CustomComponent: form?.customComponent,
        updateValues: form?.updateValues,
      };
    case "custom-nowrap":
      return {
        type: "custom-nowrap",
        CustomComponent: form?.customComponent,
        updateValues: form?.updateValues,
      };
    case "multiselect":
      return {
        type: "multiselect",
        options: form?.options,
      };
    case "dateRange":
      return {
        type: "dateRange",
      };
    case "date":
      return {
        type: "date",
      };
    case "btnType":
      return {
        type: "btnType",
      };
    default:
      return {
        type: "text",
      };
  }
}
const CreateLayout = ({
  forms,
  toggle,
  onSubmit,
  loading,
  loader = false,
  path,
  className,
  cancel = true,
  cancelText = "Cancel",
  submit = true,
  submitText = "Submit",
  onCancel = () => {},
  handleFormValue = () => {},
}) => {
  // ** react hook forms
  const history = useHistory();
  const {
    handleSubmit,
    reset,
    control,
    watch,
    setValue,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    handleFormValue && handleFormValue(watch());
  }, [watch()]);

  const btn = [...forms]?.find((item) => item?.type === "btnType");
  return (
    <SkeletonLoading loading={loader} style={{ height: 350 }}>
      <FormWrapper
        className={`form row ${className ?? ""}`}
        onSubmit={handleSubmit(onSubmit)}
      >
        {[...forms]
          ?.filter((item) => item?.type !== "btnType")
          ?.map((form, index) => {
            const {
              name,
              placeholder,
              rules = () => {},
              event,
              value,
              label,
              eventFunction,
              defaultValue = "",
              isDisplayed = () => true,
              fields,
              disabled = false,
              base64 = false,
            } = form;
            const { type, step, options, mask, CustomComponent, updateValues } =
              formTypeCheck(form);
            return (
              <React.Fragment key={index}>
                {isDisplayed({ watch }) && (
                  <>
                    {type === "custom" ? (
                      <Col
                        className="custom-parent"
                        {...{ [form.device ?? "md"]: form.deviceSize ?? 12 }}
                        key={index}
                      >
                        <div className="form__form-group">
                          {label && (
                            <span className="form__form-group-label">
                              {label}
                            </span>
                          )}
                          <div
                            className={`form__form-group-field ${
                              type === "password" ? "password" : ""
                            }`}
                          >
                            <Controller
                              name={name}
                              control={control}
                              defaultValue={defaultValue ?? ""}
                              rules={rules()}
                              render={({ field }) => (
                                <CustomComponent
                                  {...field}
                                  defaultValue={updateValues ?? ""}
                                  base64={base64}
                                  setValue={setValue}
                                  setError={setError}
                                  errors={errors}
                                  control={control}
                                  watch={watch}
                                  updateValues={updateValues ?? {}}
                                  name={name}
                                  clearErrors={clearErrors}
                                  placeholder={placeholder}
                                />
                              )}
                            />
                          </div>

                          <p className="text-danger">{errors[name]?.message}</p>
                        </div>
                      </Col>
                    ) : type === "custom-nowrap" ? (
                      <CustomComponent
                        setValue={setValue}
                        setError={setError}
                        errors={errors}
                        control={control}
                        watch={watch}
                        updateValues={updateValues ?? {}}
                        name={name}
                        clearErrors={clearErrors}
                        placeholder={placeholder}
                      />
                    ) : type === "location" ? (
                      <LocationPicker
                        setValue={setValue}
                        errors={errors}
                        control={control}
                        fields={fields}
                        watch={watch}
                      />
                    ) : type === "date" ? (
                      <Col
                        {...{ [form.device ?? "md"]: form.deviceSize ?? 12 }}
                        key={index}
                      >
                        <div className="form__form-group">
                          {label && (
                            <span className="form__form-group-label">
                              {label}
                            </span>
                          )}
                          <div
                            className={`form__form-group-field ${
                              type === "password" ? "password" : ""
                            }`}
                          >
                            <Controller
                              name={name}
                              control={control}
                              defaultValue={defaultValue ?? ""}
                              rules={rules()}
                              render={({ field }) => {
                                return (
                                  <DatePicker
                                    {...field}
                                    selected={field.value}
                                    onChange={(dates) => field.onChange(dates)}
                                    isClearable
                                    placeholderText={placeholder}
                                    minDate={form.minDate ?? undefined}
                                    maxDate={form.maxDate ?? undefined}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                  />
                                );
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    ) : type === "dateRange" ? (
                      <Col
                        {...{ [form.device ?? "md"]: form.deviceSize ?? 12 }}
                        key={index}
                      >
                        <div className="form__form-group">
                          {label && (
                            <span className="form__form-group-label">
                              {label}
                            </span>
                          )}
                          <div
                            className={`form__form-group-field ${
                              type === "password" ? "password" : ""
                            }`}
                          >
                            <Controller
                              name={name}
                              control={control}
                              defaultValue={defaultValue ?? ""}
                              rules={rules()}
                              render={({ field }) => (
                                <DatePicker
                                  {...field}
                                  selectsRange
                                  startDate={field.value && field.value[0]}
                                  endDate={field.value && field.value[1]}
                                  onChange={(dates) => field.onChange(dates)}
                                  isClearable
                                  placeholderText={placeholder}
                                  dateFormat="dd/MM/yyyy"
                                  disabled={disabled}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </Col>
                    ) : (
                      <Col
                        {...{ [form.device ?? "md"]: form.deviceSize ?? 12 }}
                        key={index}
                      >
                        <div className="form__form-group">
                          {label && (
                            <span className="form__form-group-label">
                              {label}
                            </span>
                          )}
                          <div
                            className={`form__form-group-field ${
                              type === "password" ? "password" : ""
                            }`}
                          >
                            <FormField
                              name={name}
                              type={type}
                              step={step}
                              control={control}
                              disabled={disabled}
                              component={
                                type === "select"
                                  ? renderSelectField
                                  : type === "multiselect"
                                  ? MultiSelectField
                                  : type === "mobile"
                                  ? renderMaskedField
                                  : type === "password"
                                  ? PasswordField
                                  : type === "textarea"
                                  ? "textarea"
                                  : type === "file"
                                  ? renderDropZoneField
                                  : type === "files"
                                  ? renderDropZoneMultiField
                                  : "input"
                              }
                              errors={errors}
                              placeholder={placeholder}
                              options={options}
                              rules={rules({ watch })}
                              mask={mask}
                              {...{
                                [event]: (e) =>
                                  eventFunction(
                                    type === "select" ? e : e.target.value,
                                    type === "select" ? name : e.target.name,
                                    setValue,
                                    clearErrors,
                                    watch
                                  ),
                                [value && "value"]: value,
                              }}
                              defaultValue={defaultValue ?? ""}
                            />
                          </div>
                        </div>
                      </Col>
                    )}
                  </>
                )}
              </React.Fragment>
            );
          })}
        <Col md={btn?.deviceSize || 12} className={`${btn?.className ?? ""}`}>
          <ButtonToolbar
            className={`form__button-toolbar ${
              btn?.toolBarClassName ?? "float-right"
            }`}
          >
            {cancel && (
              <Button
                type="button"
                className="btn-sm m-0 mr-2"
                color="danger"
                onClick={() => {
                  if (path) {
                    history.push(path);
                  }
                  if (toggle) {
                    toggle();
                  }
                  forms.map((form) => {
                    return setValue(`${form.name}`, "");
                  });
                  onCancel();
                }}
              >
                {cancelText}
              </Button>
            )}
            {submit && (
              <Button
                color="primary"
                disabled={loading}
                type="submit"
                className="btn-sm m-0"
              >
                {loading ? <SubmitLoading color="white" /> : submitText}
              </Button>
            )}
          </ButtonToolbar>
        </Col>
      </FormWrapper>
    </SkeletonLoading>
  );
};

export default CreateLayout;

export const FormWrapper = styled.form`
  .react-datepicker-wrapper {
    width: 100% !important;
  }
  .react-datepicker-wrapper input {
    min-height: 40px !important;
    text-align: start;
    padding-left: 10px;
  }
`;
